@if (
	!(
		currentUser?.savedFilters &&
		currentUser?.savedFilters?.length &&
		globalActiveClients &&
		globalActiveClients?.length === 0
	)
) {
	<div
		class="dropdown"
		(jepClickOutside)="onClickedOutside()"
		data-test="global-client-dropdown"
	>
		@if (isActiveClientsFetching$ | async) {
			<mat-spinner
				[diameter]="28"
				class="spinner-center spinner"
				data-test="mat-spinner"
			></mat-spinner>
		}

		@if (!(isActiveClientsFetching$ | async)) {
			<div>
				<!-- NO RESULTS -->
				@if (globalActiveClients?.length === 0) {
					<a
						class="dropdown__selected"
						(click)="createNewClient()"
						data-test="create-new-client"
					>
						<div class="pulsing-dot"></div>
						<jep-avatar
							[icon]="'icon-plus'"
							[src]="null"
							[name]="null"
							[theme]="'dark'"
							style="
								display: inline-block;
								vertical-align: middle;
							"
						>
						</jep-avatar>
						<span class="dropdown__selected-text"
							>Create a client</span
						>
					</a>
				} @else {
					<!-- SELECTED CLIENT -->
					<div class="dropdown__selected">
						<a (click)="toggleDropdownBoxState($event)">
							<jep-avatar
								[name]="
									
										selectedClient?.name
									
								"
								[agencyName]="
									
										selectedClient?.agencyName
									
								"
								[src]="
									
										selectedClient?.logo
									
								"
								[theme]="'dark'"
								style="
									display: inline-block;
									vertical-align: middle;
								"
							>
							</jep-avatar>
							<span class="dropdown__selected-text">{{
								selectedClient?.name
									| jepLimitCharacters: 30
							}}</span>
							<span
								class="icon-chevron-down"
								style="
									display: inline-block;
									vertical-align: middle;
								"
							></span>
						</a>
					</div>
				}

				<!-- DROPDOWN LIST AND SEARCH -->
				<div
					class="dropdown__box"
					[@dropdownBoxState]="dropdownBoxState"
				>
					<!-- SEARCH BAR -->
					<div
						class="dropdown__search-box"
						[ngStyle]="{
							display:
								dropdownListHeight < 272 &&
								searchText != '' &&
								searchText?.length <= 0
									? 'none'
									: 'block',
						}"
					>
						<span class="icon-search"></span>
						<input
							#search
							(ngModelChange)="onSearch($event)"
							[(ngModel)]="searchText"
							placeholder="Search"
						/>
						<!-- <input placeholder="Search"  matInput (input)="onSearch($event)" /> -->
					</div>

					<ul #dropdownClients class="dropdown__list">
						@if (noResults) {
							<li class="dropdown__item">
								<span class="dropdown__label"
									>Sorry, no results found.</span
								>
							</li>
						}
						<!-- RESULTS WITH SCROLL BAR -->
						@if (dropdownListHeight >= 272) {
							<ng-scrollbar [autoUpdate]="true">
								@for (
									client of globalActiveClients;
									track client
								) {
									<li
										class="dropdown__item"
										data-test="client-dropdown-item"
									>
										<a
											class="dropdown__link"
											mat-button
											disableRipple
											(click)="
												onClickSelectClient(client)
											"
										>
											<jep-avatar
												[name]="
													
														client?.name
													
												"
												[src]="
													
														client?.logo
													
												"
												size="small"
												theme="dark"
											></jep-avatar>
											<span
												class="client-name"
												[ngClass]="{
													bold:
														client?.name ===
														'All Clients',
												}"
												>{{ client?.name }}</span
											>
										</a>
									</li>
								}
							</ng-scrollbar>
						} @else {
							<!-- NO SCROLL BAR / NO RESULTS FOUND -->
							@if (!noResults) {
								@for (
									client of globalActiveClients;
									track client;
									let i = $index
								) {
									<li
										class="dropdown__item"
										data-test="client-dropdown-item"
									>
										<a
											class="dropdown__link"
											mat-button
											disableRipple
											(click)="
												onClickSelectClient(client)
											"
										>
											<jep-avatar
												[name]="
													
														client?.name
													
												"
												[src]="
													
														client?.logo
													
												"
												[agencyName]="
													
														client?.agencyName
													
												"
												size="small"
												theme="dark"
												style="
													display: inline-block;
													vertical-align: middle;
												"
											></jep-avatar>
											<span
												class="client-name"
												[ngClass]="{
													bold:
														client?.name ===
														'All Clients',
												}"
												>{{ client?.name }}</span
											>
										</a>
									</li>
								}
							}
						}
					</ul>

					<!-- NEW CLIENT -->
					<ul class="dropdown__nav">
						<li>
							<a
								class="dropdown__add-new"
								(click)="createNewClient()"
								mat-button
								disableRipple
								data-test="add-new-client"
							>
								<span class="icon-plus"></span>
								<span>New Client</span>
							</a>
						</li>
					</ul>
				</div>
			</div>
		}
	</div>
}
